var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadMediaCv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 17.5V21.2103C5.83301 25.9426 5.83301 28.3087 7.12519 29.9114C7.38625 30.2352 7.68117 30.5301 8.00495 30.7911C9.60763 32.0833 11.9738 32.0833 16.706 32.0833C17.735 32.0833 18.2494 32.0833 18.7206 31.9171C18.8186 31.8825 18.9145 31.8427 19.0083 31.7979C19.4591 31.5822 19.8228 31.2185 20.5504 30.491L27.4578 23.5836C28.3008 22.7405 28.7223 22.3191 28.9444 21.783C29.1663 21.247 29.1663 20.6509 29.1663 19.4587V14.5833C29.1663 9.0836 29.1663 6.33375 27.4578 4.6252C25.7493 2.91666 22.9993 2.91666 17.4997 2.91666M18.958 31.3542V30.625C18.958 26.5002 18.958 24.4379 20.2394 23.1564C21.5209 21.875 23.5833 21.875 27.708 21.875H28.4372",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.583 7.29166C13.7228 6.40668 11.4334 2.91666 10.208 2.91666C8.98261 2.91666 6.69319 6.40668 5.83301 7.29166M10.208 4.37499V14.5833",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadMediaCv);
export default __webpack_public_path__ + "static/media/UploadMediaCV.0e5292af3243cee79d2d7a5185ff3ca5.svg";
export { ForwardRef as ReactComponent };